<template>
    <ul class="collection collection-alone with-header" id="filter-categorias">
        <li class="collection-header pl-0">
            <span class="Search__title grey-text pl-0">{{ title }}</span>
        </li>
        <li
            class="collection-item dismissable pb-0"
            style="
                touch-action: pan-y;
                -webkit-user-drag: none;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
            v-for="item in categoriasPadrao"
            v-bind:key="item.categoria_id"
        >
            <input
                type="checkbox"
                v-model="categorias"
                :value="item.categoria_id"
                :id="`categoria${item.categoria_id}`"
                v-on:change="$emit('change', categorias)"
            />
            <label :for="`categoria${item.categoria_id}`"></label>
            <span class="title title-alone" style="width: 100%">{{
                item.categoria_nome
            }}</span>
        </li>
    </ul>
</template>

<script>
import { get } from "@/helpers/api";

export default {
    name: "FiltroPorCategorias",

    props: {
        title: {
            type: String,
            default: undefined
        },
        categorias: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            categoriasPadrao: []
        };
    },

    mounted() {
        get("categoria").then(response => {
            this.categoriasPadrao = response.data.result.data;
        });
    },

    methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/lead/listagem/FiltroPorCategoria.vue